import React, { Component } from 'react';
import { Route, Link } from 'react-router-dom';
import classNames from 'classnames/bind';
import styles from './ButtonLink.css';
const cx = classNames.bind(styles);

const ButtonLink = ({ label, onClick, to, activeOnlyWhenExact }) => (
  <Route
    path={to}
    exact={activeOnlyWhenExact}
    children={({ match }) => (
      <div className={match ? cx('bt-link', 'active') : cx('bt-link')}>
        <Link className={cx('full-area')} to={to} onClick={onClick}>
          {label}
        </Link>
      </div>
    )}
  />
);

export default ButtonLink;



// WEBPACK FOOTER //
// ./src/script/components/common/ButtonLink.js